import { Component, type ErrorInfo, type ReactNode } from 'react';
import i18n from 'i18next';
import EmptyState from '@/components/ui/EmptyState';

interface Props { children: ReactNode; fallback?: ReactNode; }
interface State { hasError: boolean; error?: Error }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  handleReload = () => {
    if (typeof window !== 'undefined') window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback) return this.props.fallback;

    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
        <EmptyState
          illustration="/empty-state.jpg"
          title={i18n.t('ui.errorBoundary.title', 'في مشكلة')}
          message={i18n.t('ui.errorBoundary.body', 'صار في خطأ مش متوقّع. حاول تحمّل الصفحة من جديد.')}
          cta={{ label: i18n.t('ui.errorBoundary.retry', 'حاول مرة تانية'), onClick: this.handleReload }}
        />
      </div>
    );
  }
}

export default ErrorBoundary;
